import { useCallback, useLayoutEffect, useState } from 'react'

import InterWebviewBridge, {
  IWbAppInfo,
  interWbSession,
  WbEnvironments,
} from '@interco/inter-webview-bridge'

import { appInfoMock } from '../mocks/appInfo'

type UseAppInfoResult = {
  appInfo: IWbAppInfo
  isLoading: boolean
  isError: boolean
  refetch: () => Promise<void>
}

export const useAppInfo = (): UseAppInfoResult => {
  const [appInfo, setAppInfo] = useState<IWbAppInfo>({} as IWbAppInfo)
  const [isLoading, setIsLoading] = useState(true)
  const [isError, setIsError] = useState(false)

  const interWb = InterWebviewBridge.getInstance()

  const getAppInfo = useCallback(async () => {
    setIsLoading(true)
    setIsError(false)

    if (
      interWb.getEnvironment() === WbEnvironments.BROWSER &&
      process.env.NODE_ENV === 'development'
    ) {
      setAppInfo(appInfoMock)
      setIsLoading(false)
      return
    }

    try {
      const data = await interWbSession.getAppInfo()
      setAppInfo(data)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('useAppInfo: failed to load app info from the native bridge', error)
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }, [interWb])

  useLayoutEffect(() => {
    getAppInfo()
  }, [getAppInfo])

  return { appInfo, isLoading, isError, refetch: getAppInfo }
}
